import React, { useEffect, useState } from 'react';
import Order from './Order';
import BootstrapSuccessError from './../BootstrapSuccessError';
import './OrderListing.scss';
import { connect } from 'react-redux';
import { getOrderItemsReturnEligibilityArr } from '../../../../actionCreators/myAccount';
import { getOrder } from '../../../../actionCreators/order';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import LKModal from '../../Modal/Modal';
import OrderSuccessPayNow from '../../Checkout/CheckoutPayment/OrderSuccessPayNow';
import BookAppointment from './BookAppointment';
import AppointmentBookedStatus from './AppointmentBookedStatus';
import { userProperties } from '../../../../CommonComponents/UserPropertiesForGA/UserProperties';
// import getSetCookie from '../../../../cookie';

export const OrderContext = React.createContext();

function OrderListing(props) {
  const {
    ordersList,
    userInfo,
    getOrderItemsReturnEligibilityArr,
    redisCommonData,
    getOrder,
    orderDetails,
    studioFlowReducer,
    returnEligibiliyDetailsArr,
    getOrderDetails,
    dataLocale,
    /* returnConfig, */ history,
    dataLocale: { YOU_HAVE_NO_ORDER_IN_ACCOUNT, OOPS_SOMETHING_WENT_WRONG },
  } = props;
  const studioFlowBookAppointmentModal = sessionStorageHelper.getItem(
    'studioFlowBookAppointmentModal'
  );
  const [isOpen, setOpen] = useState(false);
  const [step, setStep] = useState(null);
  const [isAppointmentBooked, setAppointmentStatus] = useState(false);
  const [isSuccessModal, openSuccessModal] = useState(false);
  useEffect(() => {
    if (ordersList) {
      getOrderItemsReturnEligibilityArr(ordersList, redisCommonData);
      // const enableNewFlowCookie = getSetCookie.getCookie('enableNewRefundFlow') || 'false';
      // if (enableNewFlowCookie === 'true' && returnConfig?.enableNewFlow) getOrderItemsReturnEligibilityArr(ordersList, redisCommonData);
    }
    userProperties(userInfo, 'order-listing-page', 'desktop', dataLocale);
  }, [userInfo]);

  useEffect(() => {
    if (studioFlowBookAppointmentModal && ordersList[0]) {
      setOpen(!isOpen);
      setStep(1);
      getOrder({
        orderId: ordersList[0].id,
        dontInitSession: true,
        isMyAcct: true,
      });
    }
  }, [ordersList]);

  useEffect(() => {
    if (isAppointmentBooked && studioFlowReducer?.bookTime) {
      getOrder({
        orderId: ordersList[0].id,
        dontInitSession: true,
        isMyAcct: true,
      });
    }
  }, [studioFlowReducer]);
  useEffect(() => {
    if (isAppointmentBooked && orderDetails) {
      setStep(0);
      openSuccessModal(!isSuccessModal);
    }
  }, [orderDetails]);
  return (
    <div className="order-list">
      {ordersList?.length > 0 && (
        <OrderContext.Provider
          value={{ userInfo, orderStatusRedis: redisCommonData?.ORDER_STATUS }}
        >
          {ordersList.map((order, index) => {
            const returnEligibiliyDetails = returnEligibiliyDetailsArr
              ? returnEligibiliyDetailsArr.find(rItem => rItem.id === order.id)
              : null;
            return (
              <Order
                key={index}
                listing
                email={userInfo.email}
                getOrderDetails={getOrderDetails}
                history={history}
                order={order}
                returnEligibiliyDetails={returnEligibiliyDetails}
              />
            );
          })}
        </OrderContext.Provider>
      )}
      {ordersList && !ordersList.length && (
        <BootstrapSuccessError
          message={YOU_HAVE_NO_ORDER_IN_ACCOUNT}
          timeout="false"
          type="warning"
        />
      )}
      {ordersList?.error && (
        <div className="col-md-12 margin-t30 clear-both alert alert-danger" role="alert">
          {OOPS_SOMETHING_WENT_WRONG}
        </div>
      )}
      {isOpen && redisCommonData?.STUDIO_FLOW_WEB && orderDetails?.result?.orders[0].studioFlow && (
        <LKModal
          backdrop="static"
          dialogClassName="timeline-video"
          hideHandler={setOpen}
          sgBookAppointment={!isAppointmentBooked}
          showModal={isOpen}
          size="large"
        >
          {step === 1 && (
            <OrderSuccessPayNow
              dataLocale={dataLocale}
              email={userInfo.email}
              hideHandler={setOpen}
              history={history}
              isOpen={isOpen}
              order={orderDetails?.result?.orders[0]}
              setStep={setStep}
            />
          )}
          {step === 2 && (
            <BookAppointment
              dataLocale={dataLocale}
              hideHandler={setOpen}
              isModalOpen={isOpen}
              order={orderDetails?.result?.orders[0]}
              orderId={orderDetails?.result?.orders[0].id}
              redisCommonData={redisCommonData}
              setAppointmentStatus={setAppointmentStatus}
              storeCode={orderDetails?.result?.orders[0].studioStoreDetails?.code}
              // storeCode="LKST530"
            />
          )}
          {isSuccessModal && (
            <AppointmentBookedStatus
              dataLocale={dataLocale}
              order={orderDetails?.result?.orders[0]}
              setAppointmnetModal={setOpen}
            />
          )}
        </LKModal>
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  returnEligibiliyDetailsArr: state.myAccount.returnEligibiliyDetailsArr,
  studioFlowReducer: state.studioFlowReducer,
  orderDetails: state.order.orderDetails,
  returnConfig: state.myAccount.returnConfig,
});

const mapDispatchToProps = dispatch => {
  return {
    getOrderItemsReturnEligibilityArr: (data, redisCommonData) =>
      dispatch(getOrderItemsReturnEligibilityArr(data, redisCommonData)),
    getOrder: data => dispatch(getOrder(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderListing);
